module.exports = __webpack_public_path__ + "img/docs-svgrepo-com.14ff7d69.svg";